import { useAtom } from "jotai";
import { memo } from "react";
import { canv } from "@/canv/global";
import { penToolMenuTypeAtom } from "@/interface/AppStore";
import { MODES } from "@/interface/SideBar/PenMenu/constants";
import { SelectableItem } from "@/interface/SideBar/PenMenu/SelectableItem";
import styles from "./PenMenu.module.css";

export const PenModeSelector = memo(() => {
    const [currentMode, setCurrentMode] = useAtom(penToolMenuTypeAtom);
    const penTool = canv.toolBox.TryGetToolByName("penTool");
    const handleClick = (mode: string) => {
        setCurrentMode(mode);
        penTool?.setMode(mode);
    };

    return (
        <>
            <div className={styles.penToolSubMenuTop}>
                {MODES.slice(0, 2).map((mode) => (
                    <SelectableItem
                        key={mode.type}
                        isSelected={currentMode === mode.type}
                        onClick={() => handleClick(mode.type)}
                        className={styles.penToolSubMenuTopItem}
                        selectedClassName={styles.penToolSubMenuTopItemSelected}
                    >
                        {mode.icon}
                    </SelectableItem>
                ))}
            </div>

            <SelectableItem
                isSelected={currentMode === MODES[2].type}
                onClick={() => handleClick(MODES[2].type)}
                className={styles.penToolSubMenuTopItem}
                selectedClassName={styles.penToolSubMenuTopItemSelected}
            >
                {MODES[2].icon}
            </SelectableItem>
        </>
    );
});
